import { useState, useEffect } from "react";
import {
  FaBuilding,
  FaBox,
  FaList,
  FaArrowRight,
  FaShieldAlt,
  FaUserTie,
  FaCheckCircle,
  FaUpload,
  FaTag,
  FaGlobe,
  FaTimes,
  FaEdit,
  FaPlus
} from "react-icons/fa";
import ProductDetails from "./ProductDetails"
import { useApi } from "../context/useApi";

const ProductsPanel = () => {
  const [expandedBrands, setExpandedBrands] = useState({});
  const [brands, setBrands] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [toast, setToast] = useState({ message: "", type: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingBrands, setIsFetchingBrands] = useState(true);
  const [modalMode, setModalMode] = useState("addBrand");
  const [tagInput, setTagInput] = useState("");
  const [categories, setCategories] = useState([]);
    const [step, setStep] = useState(1); 
const [variantInput, setVariantInput] = useState({
  description: "",
  mrp: "",
  selling_price: "",
});
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [editingBrandId, setEditingBrandId] = useState(null);
  const [variants, setVariants] = useState([]);
    const { apiFetch } = useApi();
  const [newBrand, setNewBrand] = useState({
    name: "",
    logo_url: "",
    brand_type: "Domestic",
    product_type: "Digital",
    industry_category: "",
    head_office_address: "",
    categories_offered: [],
    productCategory_count: 0,
    brand_admin_id: "",
    subscription_plan: "Free",
    is_active: false,
    is_listed: false,
    brand_registration_number: "",
  });
  const [newProduct, setNewProduct] = useState({
    product_name: "",
    description: "",
    product_image_url: "",
    brand_id: "",
    brand_name: "",
    product_link: "",
    primary_category: "",
    product_type: "",
    secondary_category: "",
    tags: [],
    remarks: "",
  });
  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };
  const API_BASE = "https://admin-backend-fbuuh6fo3q-el.a.run.app/brands";

useEffect(() => {
  const fetchBrandsWithProduct = async () => {
    setIsFetchingBrands(true);
    try {
      const res = await apiFetch(`${API_BASE}/brands/products`);
      if (!res) return;
      const data = await res.json();
      if (res.ok) {
        setBrands(data.brands || []);
      } else {
        showToast(data.error || "Failed to fetch brands", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Something went wrong while fetching brands", "error");
    } finally {
      setIsFetchingBrands(false);
    }
  };

  fetchBrandsWithProduct();
}, [apiFetch]);

useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await apiFetch(
        "https://admin-backend-fbuuh6fo3q-el.a.run.app/productcategory/get-categories"
      );
      if (!res) return;
      const data = await res.json();
      if (res.ok && data.success) {
        setCategories(data.data || []);
      } else {
        showToast(data.error || "Failed to fetch categories", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Something went wrong while fetching categories", "error");
    }
  };

  fetchCategories();
}, [apiFetch]);

  const toggleExpand = (brandId) => {
    setExpandedBrands((prev) => ({
      ...prev,
      [brandId]: !prev[brandId],
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewBrand((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setNewBrand((prev) => ({
          ...prev,
          logo_url: reader.result,
        }));
      };

      reader.readAsDataURL(file);
    }
  };
  const handleProductLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setNewProduct((prev) => ({
          ...prev,
          product_image_url: reader.result,
        }));
      };

      reader.readAsDataURL(file);
    }
  };

  const handleAddBrand = async () => {
    if (
      !newBrand.name ||
      !newBrand.brand_type ||
      !newBrand.industry_category ||
      !newBrand.head_office_address ||
      !newBrand.logo_url ||
      !newBrand.product_type ||
      !newBrand.brand_registration_number
    ) {
      showToast("Please fill all mandatory fields (*)", "error");
      return;
    }

    if (!newBrand.is_active || !newBrand.is_listed) {
      showToast("Please confirm the brand is Active and Listed", "error");
      return;
    }
    setIsLoading(true);
    try {
      const res = await apiFetch(`${API_BASE}/add-brand`, {
        method: "POST",
        body: JSON.stringify(newBrand),
      });
if (!res) return;
      const data = await res.json();

      if (res.ok) {
        showToast(data.message || "Brand added successfully!", "success");
        setIsModalOpen(false);
        const refreshed = await fetch(`${API_BASE}/brands/products`);
        const refreshedData = await refreshed.json();
        setBrands(refreshedData.brands || []);
        setNewBrand({
          name: "",
          logo_url: "",
          brand_type: "Domestic",
          product_type: "Digital",
          industry_category: "",
          head_office_address: "",
          productCategory_count: 0,
          categories_offered: [],
          is_active: false,
          is_listed: false,
          brand_admin_id: "",
          subscription_plan: "Free",
          brand_registration_number: "",
        });
      } else {
        showToast(data.error || "Failed to add brand", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Something went wrong! Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  };
  const handleEditBrand = async (brandId, updatedBrand) => {
    setIsLoading(true);
    try {
      const res = await apiFetch(`${API_BASE}/update-brand/${brandId}`, {
        method: "PUT",
        body: JSON.stringify(updatedBrand),
      });
        if (!res) return;

      const data = await res.json();

      if (res.ok) {
        showToast(data.message || "Brand updated successfully!", "success");
        const refreshed = await apiFetch(`${API_BASE}/brands/products`);
        const refreshedData = await refreshed.json();
        setBrands(refreshedData.brands || []);
        setIsModalOpen(false);
        setEditingBrandId(null);
        setNewBrand({
          name: "",
          logo_url: "",
          brand_type: "Domestic",
          product_type: "Digital",
          industry_category: "",
          head_office_address: "",
          productCategory_count: 0,
          categories_offered: [],
          is_active: false,
          is_listed: false,
          brand_admin_id: "",
          subscription_plan: "Free",
          brand_registration_number: "",
        });
      } else {
        showToast(data.error || "Failed to update brand", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Something went wrong! Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  };
const handleAddProduct = async () => {
  if (
    !newProduct.product_name ||
    !newProduct.brand_id ||
    !newProduct.primary_category ||
    !newProduct.secondary_category ||
    !newProduct.product_image_url ||
    !newProduct.product_type
  ) {
    showToast("Please fill all mandatory fields (*)", "error");
    return;
  }

  setIsLoading(true);
  try {
    const payload = { ...newProduct, variants };

    const response = await apiFetch(`${API_BASE}/products/add-product`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    if (!response) return;

    const data = await response.json();

    if (response.ok) {
      showToast(data.message || "Product added successfully!", "success");

      const refreshed = await apiFetch(`${API_BASE}/brands/products`);
      const refreshedData = await refreshed.json();
      setBrands(refreshedData.brands || []);

      setIsModalOpen(false);
      setStep(1);
      setVariants([]);
      setVariantInput({ description: "", mrp: "", selling_price: "" });
      setNewProduct({
        product_name: "",
        description: "",
        product_image_url: "",
        brand_id: "",
        brand_name: "",
        primary_category: "",
        secondary_category: "",
        tags: [],
        product_type: "",
        remarks: "",
      });
    } else {
      showToast(data.error || "Failed to add product", "error");
    }
  } catch (err) {
    console.error(err);
    showToast("Something went wrong!", "error");
  } finally {
    setIsLoading(false);
  }
};
  const closeModal = () => {
    setIsModalOpen(false);
    setEditingBrandId(null);
    
    setNewBrand({
      name: "",
      logo_url: "",
      brand_type: "Domestic",
      product_type: "Digital",
      industry_category: "",
      head_office_address: "",
      productCategory_count: 0,
      categories_offered: [],
      is_active: false,
      is_listed: false,
      brand_admin_id: "",
      subscription_plan: "Free",
      brand_registration_number: "",
    });
    
    setNewProduct({
      product_name: "",
      description: "",
      product_image_url: "",
      brand_id: "",
      brand_name: "",
      product_link: "",
      primary_category: 0,
      secondary_category: "",
      product_type: "",
      tags: [],
      remarks: "",
    });
  };

  return (
    <>
      {!selectedProduct ? (
        <>
          {" "}
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-10">
            <div>
              <h2 className="text-2xl font-semibold text-gray-800">Products</h2>
              <p className="text-sm text-gray-500">
                Manage your product listings, categories, and associated brand
                details.
              </p>
            </div>

            <button
              onClick={() => {
                setModalMode("addBrand");
                setEditingBrandId(null);
                setNewBrand({
                  name: "",
                  logo_url: "",
                  brand_type: "Domestic",
                  product_type: "Digital",
                  industry_category: "",
                  head_office_address: "",
                  productCategory_count: 0,
                  categories_offered: [],
                  is_active: false,
                  is_listed: false,
                  brand_admin_id: "",
                  subscription_plan: "Free",
                  brand_registration_number: "",
                });
                setIsModalOpen(true);
              }}
              className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white border bg-gray-900 rounded-lg hover:bg-gray-800"
            >
              <FaPlus />
              Add Brand
            </button>
          </div>
          <div className="space-y-8">
            {isFetchingBrands ? (
              <>
                {[1, 2, 3].map((i) => (
                  <div
                    key={i}
                    className="border-2 border-gray-200 rounded-xl p-5 animate-pulse"
                  >
                    {/* Brand Header */}
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 border-2 border-gray-300 rounded-lg"></div>
                        <div className="h-5 w-32 border border-gray-300 rounded"></div>
                      </div>
                      <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                        <div className="h-9 w-32 border border-gray-300 rounded-lg"></div>
                        <div className="h-9 w-28 border border-gray-300 rounded-lg"></div>
                      </div>
                    </div>

                    {/* Product Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                      {[1, 2, 3].map((j) => (
                        <div
                          key={j}
                          className="flex flex-col items-center border border-gray-200 rounded-lg p-4"
                        >
                          <div className="w-40 h-28 border border-gray-300 rounded-lg mb-3"></div>
                          <div className="h-4 w-24 border border-gray-300 rounded"></div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              brands.map((brand) => {
                const isExpanded = expandedBrands[brand.brand_id];
                const visibleProducts = isExpanded
                  ? brand.products
                  : (brand.products || []).slice(0, 3);

                return (
                  <div
                    key={brand.brand_id}
                    className="border rounded-xl shadow-md p-5 bg-white"
                  >
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4">
                      {/* Left side: Brand Logo + Name */}
                      <div className="flex items-center gap-3">
                        <img
                          src={brand.logo_url}
                          alt={`${brand.name} logo`}
                          className="w-10 h-10 object-contain rounded-lg"
                        />
                        <h4 className="text-lg font-semibold">{brand.name}</h4>
                      </div>

                      {/* Right side: Buttons */}
                      <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                        <button
                          onClick={() => {
                            setModalMode("addProduct");
                            setNewProduct({
                              ...newProduct,
                              brand_id: brand.brand_id,
                              brand_name: brand.name,
                            });
                            setIsModalOpen(true);
                          }}
                          className="px-3 py-1.5 text-sm sm:text-base rounded-lg flex items-center justify-center gap-2  text-white border bg-gray-900  hover:bg-gray-800"
                        >
                          <FaPlus /> Add Product
                        </button>

                        <button
                          onClick={() => {
                            setNewBrand(brand);
                            setModalMode("editBrand");
                            setIsModalOpen(true);
                            setEditingBrandId(brand.brand_id);
                          }}
                          className="px-3 py-1.5 text-sm sm:text-base rounded-lg flex items-center justify-center gap-2 border border-black text-blue-600 hover:bg-blue-50 transition"
                        >
                          Edit Brand
                        </button>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                      {visibleProducts.map((product) => (
                        <div
                          key={product.product_id}
                          onClick={() => setSelectedProduct(product)}
                          className="flex flex-col items-center border rounded-lg p-4 hover:shadow-md transition"
                        >
                          <div className="w-40 h-28 bg-gray-100 rounded-lg overflow-hidden flex items-center justify-center mb-3">
                            <img
                              src={product.product_image_url}
                              alt={product.product_name}
                              className="w-full h-full object-contain rounded-lg"
                            />
                          </div>
                          <h5 className="font-medium text-center">
                            {product.product_name}
                          </h5>
                        </div>
                      ))}
                    </div>

                    {brand.products && brand.products.length > 3 && (
                      <div className="flex justify-center mt-4">
                        <button
                          onClick={() => toggleExpand(brand.brand_id)}
                          className="px-4 py-2 text-blue-600 hover:underline"
                        >
                          {isExpanded ? "Show Less" : "View All"}
                        </button>
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </>
      ) : (
        <ProductDetails
          product={selectedProduct}
          goBack={() => setSelectedProduct(null)}
        />
      )}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
              <h3 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                {modalMode === "addBrand" && (
                  <>
                    <FaBuilding className="text-purple-600" />
                    Add New Brand
                  </>
                )}
                {modalMode === "editBrand" && (
                  <>
                    <FaEdit className="text-purple-600" />
                    Edit Brand
                  </>
                )}
                {modalMode === "addProduct" && (
                  <>
                    <FaBox className="text-green-600" />
                    Add Product
                  </>
                )}
              </h3>
              <button
                onClick={() => setIsModalOpen(false)}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <FaTimes className="text-gray-500" />
              </button>
            </div>

            <div className="p-6">
              {modalMode === "addProduct" ? (
                step === 1 ? (
                  <div className="space-y-6">
                    <div className="bg-green-50 rounded-lg p-4 mb-6">
                      <h4 className="font-semibold text-green-900 mb-2">
                        Step 1 of 2: Product Details
                      </h4>
                      <p className="text-sm text-green-700">
                        Enter the basic information about your product
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Product Name <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={newProduct.product_name}
                          onChange={(e) =>
                            setNewProduct({
                              ...newProduct,
                              product_name: e.target.value,
                            })
                          }
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                          placeholder="Enter product name"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Product Type <span className="text-red-500">*</span>
                        </label>
                        <select
                          value={newProduct.product_type || ""}
                          onChange={(e) =>
                            setNewProduct({
                              ...newProduct,
                              product_type: e.target.value,
                            })
                          }
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                        >
                          <option value="">Select Product Type</option>
                          <option value="physical">Physical</option>
                          <option value="digital">Digital</option>
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Primary Category{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <select
                          value={newProduct.primary_category}
                          onChange={(e) =>
                            setNewProduct({
                              ...newProduct,
                              primary_category: e.target.value,
                              secondary_category: "",
                            })
                          }
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                        >
                          <option value="">Select Primary Category</option>
                          {categories
                            .filter((cat) => cat.parent_category === "none")
                            .map((cat) => (
                              <option key={cat.id} value={cat.category_name}>
                                {cat.category_name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Secondary Category
                        </label>
                        <select
                          value={newProduct.secondary_category}
                          onChange={(e) =>
                            setNewProduct({
                              ...newProduct,
                              secondary_category: e.target.value,
                            })
                          }
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                        >
                          <option value="">Select Secondary Category</option>
                          {categories
                            .filter(
                              (cat) =>
                                cat.parent_category ===
                                newProduct.primary_category
                            )
                            .map((cat) => (
                              <option key={cat.id} value={cat.category_name}>
                                {cat.category_name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="md:col-span-2">
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Product Link
                        </label>
                        <div className="relative">
                          <FaGlobe className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                          <input
                            type="url"
                            value={newProduct.product_link}
                            onChange={(e) =>
                              setNewProduct({
                                ...newProduct,
                                product_link: e.target.value,
                              })
                            }
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                            placeholder="https://example.com/product"
                          />
                        </div>
                      </div>

                      <div className="md:col-span-2">
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Product Image
                        </label>
                        <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-green-400 transition-colors">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleProductLogoUpload}
                            className="hidden"
                            id="product-image-upload"
                          />
                          <label
                            htmlFor="product-image-upload"
                            className="cursor-pointer flex flex-col items-center"
                          >
                            {newProduct.product_image_url ? (
                              <img
                                src={newProduct.product_image_url}
                                alt="Product Preview"
                                className="h-32 object-contain rounded-lg"
                              />
                            ) : (
                              <>
                                <FaUpload className="text-3xl text-gray-400 mb-2" />
                                <span className="text-sm text-gray-600">
                                  Click to upload product image
                                </span>
                              </>
                            )}
                          </label>
                        </div>
                      </div>

                      <div className="md:col-span-2">
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Tags
                        </label>
                        <div className="flex gap-2">
                          <div className="relative flex-1">
                            <FaTag className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                            <input
                              type="text"
                              value={tagInput}
                              onChange={(e) => setTagInput(e.target.value)}
                              onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  if (
                                    tagInput.trim() &&
                                    !newProduct.tags.includes(tagInput.trim())
                                  ) {
                                    setNewProduct({
                                      ...newProduct,
                                      tags: [
                                        ...newProduct.tags,
                                        tagInput.trim(),
                                      ],
                                    });
                                    setTagInput("");
                                  }
                                }
                              }}
                              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                              placeholder="Type a tag and press Enter"
                            />
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              if (
                                tagInput.trim() &&
                                !newProduct.tags.includes(tagInput.trim())
                              ) {
                                setNewProduct({
                                  ...newProduct,
                                  tags: [...newProduct.tags, tagInput.trim()],
                                });
                                setTagInput("");
                              }
                            }}
                            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                          >
                            Add Tag
                          </button>
                        </div>
                        {newProduct.tags.length > 0 && (
                          <div className="flex flex-wrap gap-2 mt-3">
                            {newProduct.tags.map((tag, idx) => (
                              <span
                                key={idx}
                                className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-green-100 text-green-800"
                              >
                                {tag}
                                <button
                                  type="button"
                                  onClick={() =>
                                    setNewProduct({
                                      ...newProduct,
                                      tags: newProduct.tags.filter(
                                        (t) => t !== tag
                                      ),
                                    })
                                  }
                                  className="ml-2 text-green-600 hover:text-green-800"
                                >
                                  <FaTimes className="text-xs" />
                                </button>
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="flex justify-between pt-6 border-t">
                      <button
                        onClick={closeModal}
                        className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() => setStep(2)}
                        className="px-6 py-2 bg-black text-white rounded-lg hover:bg-black transition-colors flex items-center gap-2"
                      >
                        Next: Add Variants
                        <FaArrowRight />
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-6">
                    <div className="bg-green-50 rounded-lg p-4 mb-6">
                      <h4 className="font-semibold text-green-900 mb-2">
                        Step 2 of 2: Product Variants
                      </h4>
                      <p className="text-sm text-green-700">
                        Add different variants for {newProduct.product_name}
                      </p>
                    </div>

                    <div className="bg-gray-50 rounded-xl p-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <FaList className="text-indigo-600" />
                        Product Variants
                      </h4>

                      <div className="grid grid-cols-3 gap-3 mb-4">
                        <input
                          type="text"
                          placeholder="Variant Description"
                          value={variantInput.description}
                          onChange={(e) =>
                            setVariantInput({
                              ...variantInput,
                              description: e.target.value,
                            })
                          }
                          className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                        />
                        <input
                          type="number"
                          placeholder="MRP (₹)"
                          value={variantInput.mrp}
                          onChange={(e) =>
                            setVariantInput({
                              ...variantInput,
                              mrp: e.target.value,
                            })
                          }
                          className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                        />
                        <div className="flex gap-2">
                          <input
                            type="number"
                            placeholder="Selling Price (₹)"
                            value={variantInput.selling_price}
                            onChange={(e) =>
                              setVariantInput({
                                ...variantInput,
                                selling_price: e.target.value,
                              })
                            }
                            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                          />
                          <button
                            onClick={() => {
                              if (variantInput.description) {
                                setVariants([...variants, variantInput]);
                                setVariantInput({
                                  description: "",
                                  mrp: "",
                                  selling_price: "",
                                });
                              }
                            }}
                            className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
                          >
                            Add
                          </button>
                        </div>
                      </div>

                      {variants.length > 0 && (
                        <div className="space-y-2">
                          {variants.map((v, idx) => (
                            <div
                              key={idx}
                              className="flex items-center justify-between bg-white rounded-lg px-4 py-3 shadow-sm"
                            >
                              <span className="text-sm text-gray-700">
                                <span className="font-semibold">
                                  {v.description}
                                </span>
                                <span className="mx-2 text-gray-400">•</span>
                                <span className="text-black font-medium">
                                  ₹{v.selling_price}
                                </span>
                                {v.mrp && v.mrp !== v.selling_price && (
                                  <span className="ml-2 text-gray-400 line-through">
                                    ₹{v.mrp}
                                  </span>
                                )}
                              </span>
                              <button
                                onClick={() =>
                                  setVariants(
                                    variants.filter((_, i) => i !== idx)
                                  )
                                }
                                className="text-red-500 hover:text-red-700 transition-colors"
                              >
                                <FaTimes />
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="flex justify-between pt-6 border-t">
                      <button
                        onClick={() => setStep(1)}
                        className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                      >
                        Back
                      </button>
                      <button
                        onClick={handleAddProduct}
                        disabled={isLoading}
                        className={`px-6 py-2 rounded-lg text-white flex items-center gap-2 ${
                          isLoading
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-black hover:bg-black"
                        } transition-colors`}
                      >
                        {isLoading ? (
                          <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                            Saving...
                          </>
                        ) : (
                          <>
                            <FaCheckCircle />
                            Save Product
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )
              ) : (
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Brand Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={newBrand.name}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                        placeholder="Enter brand name"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Brand Type <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="brand_type"
                        value={newBrand.brand_type}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                      >
                        <option value="Domestic">Domestic</option>
                        <option value="International">International</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Product Type <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="product_type"
                        value={newBrand.product_type}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                      >
                        <option value="Digital">Digital</option>
                        <option value="Physical">Physical</option>
                        <option value="Mixed">Mixed</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Industry Category{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="industry_category"
                        value={newBrand.industry_category}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                        placeholder="e.g., Fashion, Electronics"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Registration Number{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="brand_registration_number"
                        value={newBrand.brand_registration_number}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                        placeholder="Enter registration number"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Subscription Plan
                      </label>
                      <select
                        name="subscription_plan"
                        value={newBrand.subscription_plan}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                      >
                        <option value="Free">Free</option>
                        <option value="Standard">Standard</option>
                        <option value="Premium">Premium</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <FaUserTie className="inline mr-1" />
                        Brand Admin ID
                      </label>
                      <input
                        type="text"
                        name="brand_admin_id"
                        value={newBrand.brand_admin_id}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                        placeholder="Admin mobile number"
                      />
                    </div>

                    {modalMode === "editBrand" && (
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Category Count
                        </label>
                        <input
                          type="number"
                          name="productCategory_count"
                          value={newBrand.productCategory_count}
                          readOnly
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 cursor-not-allowed"
                        />
                      </div>
                    )}

                    <div className="md:col-span-2">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Head Office Address{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        name="head_office_address"
                        value={newBrand.head_office_address}
                        onChange={handleInputChange}
                        rows="3"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2  focus:border-transparent transition-all"
                        placeholder="Complete address"
                      />
                    </div>

                    {modalMode === "editBrand" &&
                      newBrand.categories_offered?.length > 0 && (
                        <div className="md:col-span-2">
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Categories Offered
                          </label>
                          <div className="bg-gray-50 rounded-lg p-4">
                            <div className="flex flex-wrap gap-2">
                              {newBrand.categories_offered.map((cat, idx) => (
                                <span
                                  key={idx}
                                  className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-purple-100 text-black"
                                >
                                  {cat}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                    <div className="md:col-span-2">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Brand Logo <span className="text-red-500">*</span>
                      </label>
                      <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-purple-400 transition-colors">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleLogoUpload}
                          className="hidden"
                          id="brand-logo-upload"
                        />
                        <label
                          htmlFor="brand-logo-upload"
                          className="cursor-pointer flex flex-col items-center"
                        >
                          {newBrand.logo_url ? (
                            <img
                              src={newBrand.logo_url}
                              alt="Logo Preview"
                              className="h-24 w-24 object-contain rounded-lg"
                            />
                          ) : (
                            <>
                              <FaUpload className="text-3xl text-gray-400 mb-2" />
                              <span className="text-sm text-gray-600">
                                Click to upload brand logo
                              </span>
                            </>
                          )}
                        </label>
                      </div>
                    </div>

                    <div className="md:col-span-2">
                      <div className="flex items-center gap-6 p-4 bg-gray-50 rounded-lg">
                        <label className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="checkbox"
                            name="is_active"
                            checked={newBrand.is_active}
                            onChange={handleInputChange}
                            className="w-5 h-5 text-purple-600 rounded "
                          />
                          <span className="font-medium text-gray-700">
                            <FaCheckCircle className="inline mr-1 text-green-600" />
                            Active Brand
                          </span>
                        </label>

                        <label className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="checkbox"
                            name="is_listed"
                            checked={newBrand.is_listed}
                            onChange={handleInputChange}
                            className="w-5 h-5 text-purple-600 rounded "
                          />
                          <span className="font-medium text-gray-700">
                            <FaShieldAlt className="inline mr-1 text-blue-600" />
                            Listed on Stock Exchange
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between pt-6 border-t">
                    <button
                      onClick={closeModal}
                      className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={
                        modalMode === "editBrand"
                          ? () => handleEditBrand(editingBrandId, newBrand)
                          : handleAddBrand
                      }
                      disabled={isLoading}
                      className={`px-6 py-2 rounded-lg text-white flex items-center gap-2 ${
                        isLoading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-black hover:bg-gray-200"
                      } transition-colors`}
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                          {modalMode === "editBrand"
                            ? "Updating..."
                            : "Saving..."}
                        </>
                      ) : (
                        <>
                          <FaCheckCircle />
                          {modalMode === "editBrand"
                            ? "Update Brand"
                            : "Add Brand"}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {toast.message && (
        <div
          className={`fixed top-5 right-5 px-4 py-2 rounded shadow-lg text-white z-50 transition ${
            toast.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {toast.message}
        </div>
      )}
    </>
  );
};

export default ProductsPanel;
